import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withDetailedIcon } from '../DetailedIcon';
var innerSvg = '<rect class="DetailedIcon__accent-color-fill" x="4.143" y="29.429" width="31.857" height="2.655"/><path class="DetailedIcon__secondary-color-fill" d="M39.5,5H9.5A2.536,2.536,0,0,0,7,7.571V26.857a2.537,2.537,0,0,0,2.5,2.572h30A2.537,2.537,0,0,0,42,26.857V7.571A2.536,2.536,0,0,0,39.5,5ZM13,24.157a.844.844,0,0,1-.843.843h-.314A.844.844,0,0,1,11,24.157V19.443a.844.844,0,0,1,.843-.843h.314a.844.844,0,0,1,.843.843ZM21,24a1,1,0,0,1-2,0V18a1,1,0,0,1,2,0Zm8,0a1,1,0,0,1-2,0V22.8a1,1,0,1,1,2,0ZM39.673,8.74l-11,10A1,1,0,0,1,28,19h-.053a1,1,0,0,1-.694-.334L19.813,10.3,12.53,14.848a1,1,0,0,1-1.06-1.7l8-5a1,1,0,0,1,1.277.183l7.328,8.245L38.327,7.26a1,1,0,1,1,1.346,1.48Z"/><path class="DetailedIcon__foreground-color-fill" d="M35.429,10.143H4.571A2.571,2.571,0,0,0,2,12.714V32a2.571,2.571,0,0,0,2.571,2.571H16.143v3.858H12.286a1.286,1.286,0,1,0,0,2.571H27.714a1.286,1.286,0,1,0,0-2.571H23.857V34.571H35.429A2.571,2.571,0,0,0,38,32V12.714A2.571,2.571,0,0,0,35.429,10.143Zm0,2.571V26.857H4.571V12.714ZM4.571,32V29.429H35.429V32Z"/>';
export var ComputerSVG = function ComputerSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ComputerSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withDetailedIcon(ComputerSVG);